export async function create(gameId, entryData, token) {
  const response = await fetch(`${baseUrl(gameId)}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': token
    },
    body: JSON.stringify({
      custom_initiative_entry: entryData
    })
  })
  const data = await response.json()
  return data
}

export async function batchCreate(gameId, entriesData, token) {
  const response = await fetch(`${baseUrl(gameId)}/batch_create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': token
    },
    body: JSON.stringify({
      entries: entriesData
    })
  })
  const data = await response.json()

  if (!response.ok) {
    throw data
  }

  return data
}

export async function update(gameId, entryId, entryData, token) {
  const response = await fetch(`${baseUrl(gameId)}/${entryId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': token
    },
    body: JSON.stringify({
      custom_initiative_entry: entryData
    })
  })
  const data = await response.json()
  return data
}

export async function destroy(gameId, entryId, token) {
  const response = await fetch(`${baseUrl(gameId)}/${entryId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': token
    }
  })
}

function baseUrl(gameId) {
  return `${window.location.protocol}//${location.host}/games/${gameId}/custom_initiative_entries`
}
